import React from 'react';
import { getImageValidationLevelName, ImageValidationLevelField } from '@models/prediction';
import { ConfigSection } from '@components/config/ConfigSection';
import RadioButtonList, { RadioButtonEntry } from '@components/config/radioButtonsList';

export interface ImageValidationLevelProps {
    imageValidationLevelList: ImageValidationLevelField[];
    value?: ImageValidationLevelField;
    onChange: (value?: ImageValidationLevelField) => void;
}

const ImageValidationLevelSection: React.FC<ImageValidationLevelProps> = ({
    imageValidationLevelList,
    value: selectedImageValidationLevel,
    onChange,
}) => {
    const imageValidationLevelRadioButtonList: RadioButtonEntry<ImageValidationLevelField>[] = imageValidationLevelList.map(
        (field) => {
            return { value: field, label: getImageValidationLevelName(field) };
        },
    );
    const onImageValidationLevelChange = (element: ImageValidationLevelField) =>
        onChange(element === selectedImageValidationLevel ? undefined : element);

    return (
        <ConfigSection title="Image Validation Level">
            <RadioButtonList
                list={imageValidationLevelRadioButtonList}
                selectedValue={selectedImageValidationLevel}
                onChange={onImageValidationLevelChange}
            />
        </ConfigSection>
    );
};

export default ImageValidationLevelSection;
